import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ModalYesNo from './ModalYesNo'
import ModalOK from './ModalOk'
import { DashLg } from 'react-bootstrap-icons';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import { User } from 'oidc-client';
import { DEBUG } from '@devexpress/analytics-core/core/utils/_debug';
import * as MySound from '../MySound';

export class ScanCarton extends Component {
    static displayName = ScanCarton.name;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedShipment: props.location.state.selectedShipment,
            alertMessage: "",
            SSCC: "",
            cartonDetail: null,
            cartonAsUOT: false,
            cartonState: "",
            devanLocationScan: "",
            expectedDevanLocation: "",
            alertBreakCartonFromPalletUOT: false,
            alertAddCartonToPalletUOT: false,
            alertAddUkCartonToShipment: false,
            alertCompleteDevanning: false,
            unknownCartonList: [],
            unknownCarton: false,
            visibleUnshippableCheckBox: true,
            disableCartonAsUOTCheckBox: false,
            disableDevanScanLocation: true,
            disableSSCCInputScan: false,
            disableCartonState: true,
            hideFullLocationButton: true,
            showScanMessage: false,
            scanMessageTitle: "",
            scanMessage: "",
            isSCSCartonLocation: false,
            toggleLocationFull: false,
            orderForCarton: "",
            newLocationForOrder: ""
        };
        this.history = props.history;

    }
    componentDidMount() {
        this.refs.ssccBarcodeScanInput.focus();
    }


    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        let progress = this.state.loading
            ? <p><em>Loading...</em></p>
            : "";
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        const handleSSCCScan = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.scanCarton();
            }
        };
        const handleDevanLocationScan = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.devanCarton();
            }
        };
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
        return (
            <>
                {alertMessage}
                {progress}
                {!this.state.toggleLocationFull && <>
                    <h4>Scan Carton</h4>
                    <Row>
                        <Col className="col-4">Shipment:</Col>
                        <Col>{this.state.selectedShipment.shipment_ref}</Col>
                        <Col><Button variant="warning" disabled={this.state.loading} onClick={() => { this.resetCartonScan() }}>Reset</Button></Col>

                    </Row>
                    {this.state.selectedShipment.hasCartonAsUOT && <Row className="mt-2" >
                        <Col className="col-4">
                        </Col>
                        <Col>
                            <Form.Check className="m-2" type='checkbox' id='uotctn' label='Carton as UOT' checked={this.state.cartonAsUOT} disabled={this.state.disableCartonAsUOTCheckBox}
                                onChange={(e) => {
                                    this.setState({ cartonAsUOT: e.target.checked });
                                    this.refs.ssccBarcodeScanInput.focus();
                                }}
                            />
                        </Col>
                    </Row>}
                    <Row className="mt-1">
                        <Col className="col-4">
                            Scan SSCC:
                        </Col>
                        <Col className="col-md-8 col-sm-8  col-8">
                            <input autoFocus="autofocus" className="form-control" type="text" placeholder="Scan carton label..."
                                value={this.state.SSCC} onKeyPress={handleSSCCScan} disabled={this.state.disableSSCCInputScan}
                                ref="ssccBarcodeScanInput"
                                onChange={(e) => {
                                    this.setState({ SSCC: e.target.value });
                                }}
                                onInput={toInputUppercase} />
                        </Col>

                    </Row>
                    <Row>
                        <Col className="col-4">Ref #:</Col>
                        {this.state.cartonDetail !== null && <Col>{this.state.cartonDetail.order_no}</Col>}
                    </Row>
                    <Row>
                        <Col className="col-4">Carton Counts:</Col>
                        {this.state.cartonDetail !== null && <Col>{this.state.cartonDetail.po_scanned_carton_count}/{this.state.cartonDetail.po_carton_count}</Col>}
                    </Row>
                    {this.state.unknownCarton && <Row className="mt-1">
                        <Col className="col-4">
                        </Col>
                        <Col className="col-md-8 col-sm-8  col-8 text-success"  >
                            <div className="p-1" style={{ backgroundColor: 'green', width: '90px', color: 'white' }}>UNKNOWN</div>
                        </Col>
                    </Row>}
                    <Row className="mt-2">
                        <Col className="col-4">
                            Carton State:
                        </Col>
                        <Col>
                            <Form.Check label="Good" name="group1" type='radio' id='good' disabled={this.state.disableCartonState}
                                ref="chkGood"
                                onChange={(e) => {
                                    if (e.target.checked) {

                                        if (this.state.cartonDetail.is_xdoc) {
                                            this.setState({ cartonState: "GOOD", expectedDevanLocation: this.state.cartonDetail.xdoc_location });
                                            if (this.state.devanLocationScan.length > 0) {
                                                setTimeout(() => {
                                                    this.devanCarton();
                                                }, 500);
                                            }
                                            else {
                                                this.refs.devanLocationScanInput.focus();
                                            }
                                            return;
                                        }
                                        if (this.state.cartonAsUOT) {
                                            this.setState({ cartonState: "GOOD", expectedDevanLocation: this.state.cartonDetail.sscc });
                                            setTimeout(() => {
                                                this.devanCarton();
                                            }, 500);
                                        }
                                        else {
                                            this.setState({ cartonState: "GOOD" });
                                            if (this.state.devanLocationScan.length > 0) {
                                                setTimeout(() => {
                                                    this.devanCarton();
                                                }, 500);
                                            }
                                            else {
                                                this.refs.devanLocationScanInput.focus();
                                            }
                                        }

                                    }
                                }}
                            />
                            <Form.Check label="Damaged" name="group1" type='radio' id='damaged' disabled={this.state.disableCartonState}
                                ref="chkDamaged"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        if (this.state.cartonDetail.is_xdoc) {
                                            this.setState({ cartonState: "DAMAGED", expectedDevanLocation: this.state.cartonDetail.xdoc_location });
                                            //this.refs.devanLocationScanInput.focus();
                                            if (this.state.devanLocationScan.length > 0) {
                                                setTimeout(() => {
                                                    this.devanCarton();
                                                }, 500);
                                            }
                                            else {
                                                this.refs.devanLocationScanInput.focus();
                                            }


                                            return;
                                        }
                                        if (this.state.cartonAsUOT) {
                                            this.setState({ cartonState: "DAMAGED", expectedDevanLocation: this.state.cartonDetail.sscc });
                                            setTimeout(() => {
                                                this.devanCarton();
                                            }, 500);
                                        }
                                        else {
                                            this.setState({ cartonState: "DAMAGED" });
                                            if (this.state.devanLocationScan.length > 0) {
                                                setTimeout(() => {
                                                    this.devanCarton();
                                                }, 500);
                                            }
                                            else {
                                                this.refs.devanLocationScanInput.focus();
                                            }
                                        }
                                    }
                                }}
                            />
                            {this.state.visibleUnshippableCheckBox && <Form.Check label="Unshippable" name="group1" type='radio' id='unshippable' disabled={this.state.disableCartonState}
                                ref="chkUnshippable"
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        this.setState({ cartonState: "UNSHIPPABLE", expectedDevanLocation: this.state.selectedShipment.unshippables_location });
                                        if (this.state.devanLocationScan.length > 0) {
                                            setTimeout(() => {
                                                this.devanCarton();
                                            }, 500);
                                        }
                                        else {
                                            this.refs.devanLocationScanInput.focus();
                                        }
                                    }
                                }}
                            />}
                        </Col>
                        <Col>
                        </Col>

                    </Row>

                    <Row className="mt-2">
                        <Col className="col-4">
                            Put To:
                        </Col>
                        <Col className="col-8">
                            {this.state.expectedDevanLocation}
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col className="col-4">
                            Confirm Locn:
                        </Col>
                        <Col className="col-6">
                            <input className="form-control" type="text" placeholder="Scan location barcode..." autoFocus="autofocus"
                                value={this.state.devanLocationScan} onKeyPress={handleDevanLocationScan} disabled={this.state.disableDevanScanLocation}
                                ref="devanLocationScanInput"
                                onChange={(e) => {
                                    this.setState({ devanLocationScan: e.target.value });
                                }}
                                onInput={toInputUppercase} />

                        </Col>
                        <Col className="col-2">
                            <Button variant="info" disabled={this.state.loading} hidden={this.state.hideFullLocationButton} onClick={() => this.setState({ toggleLocationFull: true, newLocationForOrder: "" })}>Full</Button>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col className="col-4">
                            <Button className="" variant="danger" disabled={this.state.loading} onClick={() => this.goto('MXDockChooseShipment', null)}>Back</Button>
                        </Col>
                        <Col className="col-8">
                            <Button className="col-8" variant="warning" disabled={this.state.loading} onClick={() => this.setState({ alertCompleteDevanning: true })}>Complete Devan</Button>
                        </Col>
                    </Row>
                    <ModalYesNo title="Change UOT" show={this.state.alertBreakCartonFromPalletUOT} message="This carton is already part of a pallet UOT - receipt by itself?" onClickNo={(e) => { this.setState({ alertBreakCartonFromPalletUOT: false }) }} onClickYes={() => { this.receiptCartonByitself() }}></ModalYesNo>
                    <ModalYesNo title="Change UOT" show={this.state.alertAddCartonToPalletUOT} message="This carton is marked for putaway by itself - add to Pallet UOT?" onClickNo={(e) => { this.setState({ alertAddCartonToPalletUOT: false }) }} onClickYes={() => { this.addCartonToPalletUOT() }}></ModalYesNo>
                    <ModalYesNo title="Unknown Carton" show={this.state.alertAddUkCartonToShipment} message={this.state.SSCC + " is not on this shipment.  Add to shipment??"} onClickNo={(e) => { this.setState({ alertAddUkCartonToShipment: false, SSCC: "" }) }} onClickYes={() => { this.addCartonToUnknownList() }}></ModalYesNo>
                    <ModalOK title={this.state.scanMessageTitle} show={this.state.showScanMessage} message={this.state.scanMessage} onClickOk={() => { this.hideOkAlert() }}  ></ModalOK>
                    <ModalYesNo title="Complete Devanning" show={this.state.alertCompleteDevanning} message="This will mark the shipment as receipted, any outstanding cartons will be marked as missing.  Continue?" onClickNo={(e) => { this.setState({ alertCompleteDevanning: false }) }} onClickYes={() => { this.completeDevan() }}></ModalYesNo>

                </>}
                {this.state.toggleLocationFull && <>
                    Set New Order Location
                    <Row className="mt-2">
                        <Col className="col-4">
                            Select Order:
                        </Col>
                        <Col>
                            <Form.Check label="EXCEPTIONS" name="group2" type='radio'
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        this.setState({ orderForCarton: "EXCEPTIONS" });
                                        this.refs.newLocationForOrderInput.focus();
                                    }
                                }}
                            />
                            {this.state.visibleUnshippableCheckBox && <Form.Check label="UNSHIPPABLES" name="group2" type='radio'
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        this.setState({ orderForCarton: "UNSHIPPABLES" });
                                        this.refs.newLocationForOrderInput.focus();
                                    }
                                }}
                            />}
                            <Form.Check label={this.state.cartonDetail.client_order_no} name="group2" type='radio' id='damaged'
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        this.setState({ orderForCarton: this.state.cartonDetail.client_order_no });
                                        this.refs.newLocationForOrderInput.focus();
                                    }
                                }}
                            />
                        </Col>
                        <Col>
                        </Col>

                    </Row>
                    <Row className="mt-1">
                        <Col className="col-4">
                            Scan New Location:
                        </Col>
                        <Col className="col-8">
                            <input className="form-control" type="text" placeholder="Scan new location barcode..."
                                value={this.state.newLocationForOrder}
                                ref="newLocationForOrderInput"
                                onKeyPress={(e) => {
                                    if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                                        this.locationFull();
                                    }
                                }}
                                onChange={(e) => {
                                    this.setState({ newLocationForOrder: e.target.value });
                                }} />
                        </Col>

                    </Row>
                    <Row className="mt-1">
                        <Col className="col-4">

                        </Col>
                        <Col className="col-8">
                            <Button className="col-8" variant="success" onClick={() => { this.locationFull() }}>Prep Location</Button>
                        </Col>

                    </Row>
                    <Row className="mt-1">
                        <Col className="col-4">

                        </Col>
                        <Col className="col-8">
                            <Button className="col-8" variant="danger" onClick={() => { this.setState({ toggleLocationFull: false, alertMessage: "", }) }}>Back</Button>
                        </Col>

                    </Row>
                    <ModalOK title={this.state.scanMessageTitle} show={this.state.showScanMessage} message={this.state.scanMessage} onClickOk={() => { this.hideOkAlert() }}  ></ModalOK>

                </>}
            </>
        );
    }

    completeDevan() {
        this.goto('SupervisorSignoff', { backUrl: 'ScanCarton', nextUrl: 'UnknownCarton', selectedShipment: this.state.selectedShipment });
    }

    locationFull() {
        if (this.state.orderForCarton.length == 0) {
            this.showOkAlert("Order Error", "Please select order first!");
            return;
        }
        if (this.state.newLocationForOrder.length == 0) {
            this.showOkAlert("Location Error", "Please scan location barcode!");
            return;
        }
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Shipment: this.state.selectedShipment,
                Order: this.state.orderForCarton,
                NewLocation: this.state.newLocationForOrder,
            })
        };

        fetch('api/MXDock/PrepNewLocationForOrder', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", expectedDevanLocation: this.state.newLocationForOrder, toggleLocationFull: false });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, SSCC: "" });
                this.refs.ssccBarcodeScanInput.focus();

            });
    }

    receiptCartonByitself() {
        var scanCartonDetail = this.state.cartonDetail;
        scanCartonDetail.xdoc_location = scanCartonDetail.sscc;
        this.setState({ cartonDetail: scanCartonDetail, alertBreakCartonFromPalletUOT: false });
        this.setDevanOptions();
    }

    addCartonToPalletUOT() {
        var scanCartonDetail = this.state.cartonDetail;
        scanCartonDetail.xdoc_location = "";
        this.setState({ cartonDetail: scanCartonDetail, alertAddCartonToPalletUOT: false });
        this.setDevanOptions();
    }

    addCartonToUnknownList() {
        let userID = MyGlobal.user;
        var unknownCarton = {
            "sscc": this.state.SSCC,
            "xdoc_location": this.state.selectedShipment.exceptions_location,
            "store_name": "UNKNOWN",
            "receipted_by": userID,
            "receipted_dt": new Date(),
            "mxd_line_id": 0
        }
        var ukCartonList = this.state.unknownCartonList;
        ukCartonList.push(unknownCarton);
        this.setState({
            unknownCartonList: ukCartonList,
            alertAddUkCartonToShipment: false,
            unknownCarton: true,
            expectedDevanLocation: this.state.selectedShipment.exceptions_location,
            disableCartonAsUOTCheckBox: true,
            visibleUnshippableCheckBox: false,
            disableSSCCInputScan: true,
            disableCartonState: false,
            disableDevanScanLocation: false,
            cartonDetail: unknownCarton

        });

    }

    runScanCartonLogic() {
        var scanCartonDetail = this.state.cartonDetail;
        if (scanCartonDetail !== null) {
            var isXDoc = scanCartonDetail.is_xdoc == 1 ? true : false;
            // if user re-scans a carton
            if (scanCartonDetail.received_state !== "MISSING" && this.state.selectedShipment.hasCartonAsUOT && !isXDoc) {
                if (this.state.cartonAsUOT) {
                    if (scanCartonDetail.xdoc_location.toUpperCase() !== scanCartonDetail.sscc.toUpperCase() && scanCartonDetail.receipted_by !== "") {
                        this.setState({ alertBreakCartonFromPalletUOT: true });
                        MySound.play(MySound.Sound.stop);
                    }
                }
                else {
                    if (scanCartonDetail.xdoc_location.toUpperCase() === scanCartonDetail.sscc.toUpperCase()) {
                        this.setState({ alertAddCartonToPalletUOT: true });
                        MySound.play(MySound.Sound.stop);
                    }
                    else {
                        this.showOkAlert("Carton As UOT", "This carton is already scanned to SCS location. If you want to mark it to putaway to itself, please tick Ctn As UOT and re-scan barcode.");
                        this.resetCartonScan();
                    }
                }
            }
            else {
                this.setDevanOptions();
                MySound.play(MySound.Sound.next);
            }
        }
        else {
            this.setState({ alertAddUkCartonToShipment: true }); // unknown carton
            MySound.play(MySound.Sound.stop);
        }

    }

    setDevanOptions() {
        var scanCartonDetail = this.state.cartonDetail;
        var isXDoc = scanCartonDetail.is_xdoc == 1 ? true : false;
        if (isXDoc) {
            this.setState({ cartonAsUOT: false, disableCartonAsUOTCheckBox: true, expectedDevanLocation: scanCartonDetail.xdoc_location, disableSSCCInputScan: true, disableCartonState: false, disableDevanScanLocation: false, hideFullLocationButton: false });
        }
        else {
            this.setState({ visibleUnshippableCheckBox: false });
            if (this.state.selectedShipment.hasCartonAsUOT) {
                if (this.state.cartonAsUOT) {
                    this.setState({ expectedDevanLocation: this.state.SSCC, devanLocationScan: this.state.SSCC, disableCartonAsUOTCheckBox: true, disableSSCCInputScan: true, disableCartonState: false });
                }
                else {
                    this.setState({ expectedDevanLocation: "Scan SCS label e.g.SCS-001", disableDevanScanLocation: false, disableCartonAsUOTCheckBox: true, disableSSCCInputScan: true, disableCartonState: false, isSCSCartonLocation: true }); // scs-001 locations needs to be scanned by user
                }
            }
            else {
                this.setState({ expectedDevanLocation: scanCartonDetail.xdoc_location, disableDevanScanLocation: false, disableSSCCInputScan: true, disableCartonState: false, hideFullLocationButton: false, });
            }
        }
    }

    devanCarton() {
        if (this.state.cartonState === "") {
            this.showOkAlert("Scan Error", "Please select carton state!");
            return;
        }
        if (!this.state.disableDevanScanLocation && this.state.devanLocationScan.length === 0) {
            this.showOkAlert("Scan Error", "Please scan correct destination location!");
            return;
        }

        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ShipmentReference: this.state.selectedShipment.shipment_ref,
                IsUnknownCarton: this.state.unknownCarton,
                ExpectedDevanLocation: this.state.expectedDevanLocation,
                ScannedDevanLocation: this.state.devanLocationScan,
                CartonState: this.state.cartonState,
                IsSCSCartonLocation: this.state.isSCSCartonLocation,
                LoggedInUser: MyGlobal.user,
                CartonId: this.state.cartonDetail !== null ? this.state.cartonDetail.mxd_line_id : 0,
                SSCC: this.state.SSCC
            })
        };

        fetch('api/MXDock/DevanCarton', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "" });
                        this.resetCartonScan();
                        MySound.play(MySound.Sound.next);
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage, devanLocationScan: "" });
                        this.refs.devanLocationScanInput.focus();
                        MySound.play(MySound.Sound.stop);
                        // this.showOkAlert("Scan Error", result.errorMessage);
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, SSCC: "" });
                this.refs.ssccBarcodeScanInput.focus();

            });

    }

    showOkAlert(messageTitle, message) {
        this.setState({ showScanMessage: true, scanMessageTitle: messageTitle, scanMessage: message });
    }

    hideOkAlert() {
        this.setState({ showScanMessage: false, scanMessageTitle: "", scanMessage: "" });
    }

    resetCartonScan() {
        this.setState({
            SSCC: "",
            cartonDetail: null,
            cartonAsUOT: false,
            cartonState: "",
            devanLocationScan: "",
            expectedDevanLocation: "",
            alertBreakCartonFromPalletUOT: false,
            alertAddCartonToPalletUOT: false,
            alertAddUkCartonToShipment: false,
            unknownCarton: false,
            visibleUnshippableCheckBox: true,
            disableCartonAsUOTCheckBox: false,
            disableDevanScanLocation: true,
            disableSSCCInputScan: false,
            disableCartonState: true,
            hideFullLocationButton: true,
            isSCSCartonLocation: false
        });
        this.refs.chkGood.checked = false;
        this.refs.chkDamaged.checked = false;
        this.refs.chkUnshippable.checked = false;
        this.refs.ssccBarcodeScanInput.focus();

    }

    async scanCarton() {
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Shipment: this.state.selectedShipment, SSCC: this.state.SSCC, cartonAsUOTFlag: this.state.cartonAsUOT })
        };
        fetch('api/MXDock/ScanSSCC', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, cartonDetail: result.data, alertMessage: "" });
                        this.runScanCartonLogic();
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage, SSCC: "" });
                        this.refs.ssccBarcodeScanInput.focus();
                        MySound.play(MySound.Sound.stop);
                        this.scanCarton("Scan Error", result.errorMessage);
                    }

                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, SSCC: "" });
                this.refs.ssccBarcodeScanInput.focus();

            });

    }
}
export default ScanCarton;

